import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, StepCard, CtaBand, Reveal } from "../components/ui.js";
import { SceneArt, Blob } from "../components/illustrations.js";

/* LEVELUP ONE — เรื่องราว (Story) */
export default class Story extends Component {
  componentDidMount() { loading(false); window.scrollTo(0, 0); }
  render() {
    const timeline = [
      { num: "2562", time: "จุดเริ่มต้น", title: "ก่อตั้งทีม", desc: "รวมตัวกันจากความตั้งใจช่วยธุรกิจไทยด้วยเทคโนโลยี" },
      { num: "2564", time: "เติบโต", title: "ส่งมอบโปรเจกต์แรก ๆ", desc: "พัฒนาเว็บและแอปให้ลูกค้าหลากหลายอุตสาหกรรม" },
      { num: "2566", time: "ก้าวสำคัญ", title: "เริ่มทำ AI Solutions", desc: "นำ AI มาช่วยงานจริงบนระบบเดิมของลูกค้า" },
      { num: "2568", time: "ปัจจุบัน", title: "พนักงาน AI สำหรับ SME", desc: "ขยายสู่โซลูชันสำเร็จรูปและทีม AI ครบวงจร" },
    ];
    return (
      <div className="nx">
        <Navbar />
        <PageHero crumb="เรื่องราว" eyebrow="เรื่องราวของเรา" title="จากความตั้งใจเล็ก ๆ สู่ทีม AI ของธุรกิจไทย"
          subtitle="เราเชื่อว่าเทคโนโลยีที่ดีควรช่วยให้คนทำงานน้อยลง แต่ได้ผลมากขึ้น" />
        <section className="nx-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-12 col-lg-6 position-relative">
                <Reveal>
                  <Blob className="nx-blob" style={{ top: -50, left: -40, opacity: 0.22 }} />
                  <SceneArt kind="team" className="nx-scene" style={{ borderRadius: 24 }} />
                </Reveal>
              </div>
              <div className="col-12 col-lg-6">
                <Reveal delay={120}>
                  <SectionHead eyebrow="ทำไมเราถึงเริ่ม" title="แก้ปัญหาจริงของร้านค้าไทย" />
                  <p className="nx-subtitle mb-3">เราเห็นเจ้าของธุรกิจหมดเวลาไปกับงานซ้ำ ๆ ทั้งคีย์ข้อมูล ตอบลูกค้า และทำรายงาน เลยตั้งใจสร้างเครื่องมือที่เข้ามาช่วยโดยไม่ต้องเปลี่ยนวิธีทำงานเดิม</p>
                  <p className="nx-subtitle">วันนี้ LevelUp One เติบโตเป็นทีมที่ส่งมอบทั้งซอฟต์แวร์และพนักงาน AI ให้ธุรกิจหลากหลายขนาด</p>
                </Reveal>
              </div>
            </div>
          </div>
        </section>
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal><SectionHead center eyebrow="เส้นทางของเรา" title="ก้าวสำคัญในแต่ละช่วงเวลา" /></Reveal>
            <div className="row g-4 mt-2">
              {timeline.map((t, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={t.num}>
                  <Reveal delay={i * 70}><StepCard {...t} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaBand />
        <Footer />
      </div>
    );
  }
}
